<template>
  <div>
    <vs-prompt
      title="Add label"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="Add"
      :is-valid="validForm"
      class="todoPopup"
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Label</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="Eg. Winter Olympics 2022"
                v-model="name"
              />
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      name: "",
      prompt: false,
    };
  },
  computed: {
    validForm() {
      return this.name !== "";
    },
  },
  methods: {
    show() {
      this.name = "";
      this.prompt = true;
    },
    async accept() {
      const dto = {
        name: this.name,
      };

      this.$vs.loading();

      await this.$store.dispatch("guestSegmentation/addLabel", dto);

      this.$vs.notify({
        color: "success",
        title: `Added`,
        text: "Added",
      });
      this.$vs.loading.close();
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
